import { jsonArrayMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminValidationSettingsUpdateRequest {
  @jsonArrayMember(String)
  public readonly nipBlacklist!: string[];

  public constructor(
    private readonly data: {
      nipBlacklist: string[];
    },
  ) {
    this.nipBlacklist = this.data.nipBlacklist;
  }
}
